import jsCookie from "js-cookie";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";


export const ghgApiSlice = createApi({
    reducerPath: "ghgApi",
    baseQuery: fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_GHG_URL}`,
        prepareHeaders: (headers) => {
            const token = jsCookie.get("token");
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    }),
    tagTypes: ['Combustion', 'Electricity', 'Transportation', 'PurchasedGoods', 'All', 'Others', 'Certifications', 'SolidAndLiquidWasteDisposal'],
    endpoints: (builder) => ({
        // 1. Combustion
        addCombustionEmissionData: builder.mutation({
            query: ({ values }) => ({
                url: `add/combustion`,
                method: 'POST',
                body: { ...values }
            }),
            invalidatesTags: ['Combustion'],
        }),
        getCombustionEmissionData: builder.query({
            query: ({ certificate_id, user_id }) => ({
                url: `combustion`,
                method: 'GET',
                params: {
                    certificate_id,
                    user_id
                }
            }),
            providesTags: (result) =>
                result?.data
                    ? result.data.map((certificate) => ({ type: 'Combustion', id: certificate._id }))
                    : ['Combustion'],
        }),



        // 2. Electricity
        addElectricityEmissionData: builder.mutation({
            query: ({ values }) => ({
                url: `add/electricity`,
                method: 'POST',
                body: { ...values }
            }),
            invalidatesTags: ['Electricity'],
        }),
        getElectricityEmissionData: builder.query({
            query: ({ certificate_id, user_id }) => ({
                url: `electricity`,
                params: {
                    certificate_id,
                    user_id
                }

            }),
            providesTags: (result) =>
                result?.data
                    ? result.data.map((certificate) => ({ type: 'Electricity', id: certificate._id }))
                    : ['Electricity'],
        }),


        // 3. Transportation
        addTransportationEmissionData: builder.mutation({
            query: ({ values }) => ({
                url: `add/transportation`,
                method: 'POST',
                body: { ...values }
            }),
            invalidatesTags: ['Transportation'],
        }),
        getTransportationEmissionData: builder.query({
            query: ({ certificate_id, user_id }) => ({
                url: `transportation`,
                params: {
                    certificate_id,
                    user_id
                }
            }),
            providesTags: (result) =>
                result?.data
                    ? result.data.map((certificate) => ({ type: 'Transportation', id: certificate._id }))
                    : ['Transportation'],
        }),


        // 4. PurchasedGoods

        addPurchasedGoodsEmissionData: builder.mutation({
            query: ({ values }) => ({
                url: `add/purchased_goods`,
                method: 'POST',
                body: { ...values }
            }),
            invalidatesTags: ['PurchasedGoods'],
        }),
        getPurchasedGoodsEmissionData: builder.query({
            query: ({ certificate_id, user_id }) => ({
                url: `purchased_goods`,
                params: {
                    certificate_id,
                    user_id
                }
            }),
            providesTags: (result) =>
                result?.data
                    ? result.data.map((certificate) => ({ type: 'PurchasedGoods', id: certificate._id }))
                    : ['PurchasedGoods'],
        }),

        // 5. All
        addAllEmissionData: builder.mutation({
            query: ({ values }) => ({
                url: `add/all`,
                method: 'POST',
                body: { ...values }
            }),
            invalidatesTags: ['All'],
        }),
        getAllEmissionData: builder.query({
            query: ({ certificate_id, user_id }) => ({
                url: `all`,
                method: 'GET',
                params: {
                    certificate_id,
                    user_id
                }
            }),
            providesTags: (result) =>
                result?.data
                    ? result.data.map((certificate) => ({ type: 'All', id: certificate._id }))
                    : ['All'],
        }),


        // 6. Others
        addOthersEmissionData: builder.mutation({
            query: ({ values }) => ({
                url: `add/others`,
                method: 'POST',
                body: { ...values }
            }),
            invalidatesTags: ['Others'],
        }),
        getOthersEmissionData: builder.query({
            query: ({ certificate_id, user_id }) => ({
                url: `others`,
                method: 'GET',
                params: {
                    certificate_id,
                    user_id
                }

            }),
            providesTags: (result) =>
                result?.data
                    ? result.data.map((certificate) => ({ type: 'Others', id: certificate._id }))
                    : ['Others'],
        }),

        // 7. Mitigation
        addMitigationData: builder.mutation({
            query: ({ values }) => ({
                url: `mitigation`,
                method: 'POST',
                body: { ...values }
            }),
            invalidatesTags: ['Mitigation'],
        }),
        getMitigationData: builder.query({
            query: ({ certificate_id, user_id }) => ({
                method: 'GET',
                url: `mitigation`,
                params: {
                    certificate_id,
                    user_id
                }
            }),
            providesTags: (result) =>
                result?.data
                    ? result.data.map((mitigation) => ({ type: 'Mitigation', id: mitigation?._id }))
                    : ['Mitigation'],
        }),
        deleteMitigationData: builder.mutation({
            query: ({ id }) => ({
                url: `delete/mitigation/${id}`,
                method: 'DELETE',
                params: { id },
            }),
            invalidatesTags: (result, error, { id }) => [{ type: 'Mitigation', id }, 'Mitigation'],
        }),
        updateMitigationData: builder.mutation({
            query: ({ updates, id }) => ({
                url: `edit/mitigation`,
                method: 'PUT',
                body: updates,
                params: { id },
            }),
            invalidatesTags: (result, error, { id }) => [
                { type: 'Mitigation', id },
                'Mitigation',
            ],
        }),

        // 8. Solid and Liquid Waste Disposal
        addSolidAndLiquidWasteDisposalData: builder.mutation({
            query: ({ values }) => ({
                method: "POST",
                url: `add/solid_and_liquid_waste`,
                body: { ...values },
                
            })
        }),
        getSolidAndLiquidWasteDisposalData: builder.query({
            query: ({ certificate_id, user_id }) => ({
                method: "GET",
                url: `solid_and_liquid_waste`,
                params: {
                    certificate_id,
                    user_id
                }
            }),
            providesTags: (result) =>
                result?.data
                    ? result.data?.map((solid_and_liquid_waste_disposal) => ({ type: 'SolidAndLiquidWasteDisposal', id: solid_and_liquid_waste_disposal?._id }))
                    : ['SolidAndLiquidWasteDisposal'],
        }),
        deleteSolidAndLiquidWasteDisposalData: builder.mutation({
            query: ({ id }) => ({
                url: `delete/solid_and_liquid_waste/${id}`,
                method: 'DELETE',
                params: { id },
            }),
            invalidatesTags: (result, error, { id }) => [{ type: 'SolidAndLiquidWasteDisposal', id }, 'SolidAndLiquidWasteDisposal'],
        }),
        updateSolidAndLiquidWasteDisposalData: builder.mutation({
            query: ({ updates, id }) => ({
                url: `edit/solid_and_liquid_waste`,
                method: 'PUT',
                body: updates,
                params: { id },
            }),
            invalidatesTags: (result, error, { id }) => [
            
        ]}),

        // 9. Inventory
        addInventoryData: builder.mutation({
            query: (formData) => ({
            method: "POST",
            url: `inventory`,
            body: formData
            })
        }),
        getInventoryData: builder.query({
            query: () => ({
            method: "GET",
            url: `inventory`,
           
        }),
        providesTags: (result) =>
            result?.data
                ? result.data?.map((inventory) => ({ type: 'Inventory', id: inventory?._id }))
                : ['Inventory'],
        }),
        deleteInventoryData: builder.mutation({
            query: ({ id }) => ({
                url: `delete/inventory`,
                method: 'DELETE',
                params: { id },
            }),
            invalidatesTags: (result, error, { id }) => [{ type: 'Inventory', id }, 'Inventory'],
        }),


        //UPDATE AND DELETE
        getEmissionDataById: builder.query({
            query: ({ endpoint, id, }) => ({
                url: `${endpoint}/${id}`,
                params: { id },
            }),
            providesTags: (result, error, { endpoint, id }) =>
                result?.id
                    ? [{ type: `${(endpoint?.slice(0, 1)).toUpperCase() + (endpoint.slice(1)).toLowerCase()}}`, id: result.id }]
                    : [`${(endpoint?.slice(0, 1)).toUpperCase() + (endpoint.slice(1)).toLowerCase()}}`], // Fallback if result.id is not available
        }),
        updateEmissionDataById: builder.mutation({
            query: ({ endpoint, updates, id }) => ({
                url: `edit/${endpoint}`,
                method: 'PUT',
                body: updates,
                params: { id },
            }),
            invalidatesTags: (result, error, { endpoint, id }) => [
                { type: `${(endpoint?.slice(0, 1)).toUpperCase() + (endpoint.slice(1)).toLowerCase()}`, id },
                `${(endpoint?.slice(0, 1)).toUpperCase() + (endpoint.slice(1)).toLowerCase()}`,
            ],
        }),

        deleteEmissionDataById: builder.mutation({
            query: ({ endpoint, id }) => ({
                url: `delete/${endpoint}`,
                method: 'DELETE',
                params: { id },
            }),
            invalidatesTags: (result, error, { endpoint, id }) => [
                { type: `${(endpoint?.slice(0, 1)).toUpperCase() + (endpoint.slice(1)).toLowerCase()}`, id },
                `${(endpoint?.slice(0, 1)).toUpperCase() + (endpoint.slice(1)).toLowerCase()}`,
            ],
        }),

        //UPDATE AND DELETE


        //Certifications
        addNewCertification: builder.mutation({
            query: ({ values }) => ({
                url: `certification`,
                method: 'POST',
                body: { ...values }
            })
        }),
        getCertificationData: builder.query({
            query: ({ user_id }) => ({
                url: `certification`,
                method: 'GET',
                params: { user_id }

            }),
            providesTags: (result) =>
                result?.data
                    ? result.data.map((certification) => ({ type: 'Certifications', id: certification._id }))
                    : ['Certifications'],
        }),
        updateCertificationData: builder.mutation({
            query: ({ updates, certId }) => ({
                url: `edit/certification/${certId}`,
                method: 'PUT',
                body: updates,
            }),
            invalidatesTags: (result, error, { certId }) => [
                { type: 'Certifications', id: certId },
                'Certifications',
            ],
        }),
        deleteCertificationData: builder.mutation({
            query: ({ certId }) => ({
                url: `delete/certification/${certId}`,
                method: 'DELETE',
            }),
            invalidatesTags: (result, error, certId) => [
                { type: 'Certifications', id: certId },
                'Certifications',
            ]
        }),

        //Users
        fetchUsersListForAdmin: builder.query({
            query: () => ({
                url: `users`,
                method: 'GET',
            }),
            providesTags: (result) =>
                result?.data
                    ? result.data.map((user) => ({ type: 'Users', id: user._id }))
                    : ['Users'],
        }),
    })
});

export const {
    // 1.Combustion
    useAddCombustionEmissionDataMutation, useGetCombustionEmissionDataQuery,

    // 2. Electricity
    useAddElectricityEmissionDataMutation, useGetElectricityEmissionDataQuery,

    // 3. Transportation
    useAddTransportationEmissionDataMutation, useGetTransportationEmissionDataQuery,

    // 4. Purchased Goods
    useAddPurchasedGoodsEmissionDataMutation, useGetPurchasedGoodsEmissionDataQuery,

    // 5. All
    useAddAllEmissionDataMutation, useGetAllEmissionDataQuery,

    // 6. Others
    useAddOthersEmissionDataMutation, useGetOthersEmissionDataQuery,

    //7. Mitigation
    useAddMitigationDataMutation, useGetMitigationDataQuery,
    useDeleteMitigationDataMutation, useUpdateMitigationDataMutation,

    // 8. Solid and Liquid Waste Disposal
    useAddSolidAndLiquidWasteDisposalDataMutation, useGetSolidAndLiquidWasteDisposalDataQuery,
    useDeleteSolidAndLiquidWasteDisposalDataMutation, useUpdateSolidAndLiquidWasteDisposalDataMutation,

    // 9. Inventory
    useAddInventoryDataMutation, useGetInventoryDataQuery,
    useDeleteInventoryDataMutation,

    //CRUD
    useGetEmissionDataByIdQuery, useUpdateEmissionDataByIdMutation,
    useDeleteEmissionDataByIdMutation,

    // Certification
    useAddNewCertificationMutation, useGetCertificationDataQuery,
    useUpdateCertificationDataMutation, useDeleteCertificationDataMutation,

    //Users
    useFetchUsersListForAdminQuery,

} = ghgApiSlice;